import { GetSystemListParameters, getSystemLists } from "@bevco/Services/CommonService";
import { CustomState } from "@bevco/Store/Reducers";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

interface Parameter {
    namelist: string;
}

interface Props {
    getSystemListsParameters: GetSystemListParameters;
    storeKeys: string[];
}

type HandlerType = Handler<Parameter, Props>;

const mapNameToStoreKey = (name: string): string => {
    switch (name.trim()) {
        case "ReturnRequestOrderResponse":
            return "return-request";
        case "ChangeOrderResponse":
            return "change-order";
        case "EditQuoteResponse":
            return "edit-quote";
        case "CancelQuoteResponse":
            return "cancel-quote";
        default:
            return name.trim();
    }
};

export const PopulateStoreKeys: HandlerType = props => {
    props.storeKeys = props.parameter.namelist.split(",").map(mapNameToStoreKey);
};

export const SkipIfAlreadyLoaded: HandlerType = props => {
    const systemList = (props.getState() as CustomState).customSystemList;
    if (props.storeKeys.every(key => Array.isArray(systemList?.[key]))) {
        return false;
    }
};

/** Mark keys as loaded immediately so SSR re-renders do not start duplicate requests. */
export const MarkAsLoading: HandlerType = props => {
    const systemList = (props.getState() as CustomState).customSystemList;
    for (const key of props.storeKeys) {
        if (!Array.isArray(systemList?.[key])) {
            props.dispatch({
                type: "Custom/SystemList/SetSystemListByKey",
                key,
                value: [],
            } as any);
        }
    }
};

export const PopulateApiParameter: HandlerType = props => {
    props.getSystemListsParameters = {
        namelist: props.parameter.namelist,
    };
};

export const FetchSystemList: HandlerType = props => {
    return getSystemLists(props.getSystemListsParameters).then(data => {
        if (data.successful && data.result) {
            for (const key in data.result) {
                let newKey = key;
                switch (key) {
                    case "ReturnRequestOrderResponse":
                        newKey = "return-request";
                        break;
                    case "ChangeOrderResponse":
                        newKey = "change-order";
                        break;
                    case "EditQuoteResponse":
                        newKey = "edit-quote";
                        break;
                    case "CancelQuoteResponse":
                        newKey = "cancel-quote";
                        break;
                }
                props.dispatch({
                    type: "Custom/SystemList/SetSystemListByKey",
                    key: newKey,
                    value: data.result[key],
                } as any);
            }
        }
    });
};

export const chain = [PopulateStoreKeys, SkipIfAlreadyLoaded, MarkAsLoading, PopulateApiParameter, FetchSystemList];

const loadSystemLists = createHandlerChainRunner(chain, "LoadSystemLists");
export default loadSystemLists;
